import { SET_SERVICE_INDICATOR } from "../actions/serviceIndicatorAction";

const ServiceIndicatorInitialState = [];

const serviceIndicatorReducer = (
  state = ServiceIndicatorInitialState,
  action
) => {
  switch (action.type) {
    case SET_SERVICE_INDICATOR:
      return action.payload;
    default:
      return state;
  }
};

export default serviceIndicatorReducer;
